import Clarity from "@microsoft/clarity"
import { readUserRole } from "./users/userRole"

const PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID
const IS_PROD = process.env.NODE_ENV === "production"

let initialized = false

const safe = (fn) => {
  try {
    fn()
  } catch (e) {
    // Clarity ne doit jamais casser l'app
    if (!IS_PROD) console.warn("[Clarity]", e)
  }
}

export const initClarity = () => {
  if (!IS_PROD || !PROJECT_ID || initialized) return
  safe(() => {
    Clarity.init(PROJECT_ID)
    initialized = true
  })
}

/**
 * Identifie l'utilisateur authentifié dans Clarity et remonte
 * les tags utiles pour le filtrage (rôle, zoo, akongoStaff).
 *
 * @param {Object} firebaseUser - utilisateur Firebase (uid, email)
 * @param {Object} userData - document Firestore /users/{uid}
 */
export const identifyClarityUser = (firebaseUser, userData) => {
  if (!IS_PROD || !PROJECT_ID || !initialized || !firebaseUser) return

  safe(() => {
    const userId = firebaseUser.uid
    const email = firebaseUser.email || userData?.userMail || userData?.email

    Clarity.identify(userId, undefined, undefined, email || undefined)

    const role = readUserRole(userData?.userRight)
    if (role) Clarity.setTag("role", role)
    const zooId = userData?.zooId || userData?.userZoo?.value
    if (zooId) Clarity.setTag("zooId", String(zooId))
    if (userData?.akongoStaff === true) Clarity.setTag("akongoStaff", "true")
    if (userData?.akongoRank) Clarity.setTag("akongoRank", String(userData.akongoRank))
  })
}

export const setClarityTag = (key, value) => {
  if (!IS_PROD || !PROJECT_ID || !initialized) return
  safe(() => Clarity.setTag(String(key), String(value)))
}
